import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Card, Button, Input } from '@/components/ui/Components';
import SafeIcon from '@/common/SafeIcon';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login, user } = useAuth();
  const navigate = useNavigate();

  // Ha már be van jelentkezve, ne engedjük ide
  useEffect(() => {
    if (user) {
      navigate(user.role === 'superadmin' ? '/superadmin' : '/admin');
    }
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const userData = await login(email, password);
      navigate(userData.role === 'superadmin' ? '/superadmin' : '/admin');
    } catch (err) {
      setError('Hibás email cím vagy jelszó');
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-900 flex items-center justify-center p-4 transition-colors">
      <Card className="w-full max-w-md p-8 shadow-xl border-0 ring-1 ring-black/5 dark:ring-white/10">
        <div className="flex justify-center mb-8">
          <div className="w-16 h-16 bg-blue-600 rounded-2xl flex items-center justify-center shadow-lg">
            <SafeIcon name="Filter" className="w-8 h-8 text-white" />
          </div>
        </div>

        <h2 className="text-3xl font-black text-center text-gray-900 dark:text-white mb-2 tracking-tight">Bejelentkezés</h2>
        <p className="text-center text-gray-500 dark:text-gray-400 mb-8 font-medium">Adminisztráció</p>

        {error && (
          <div className="mb-6 p-4 bg-red-50 dark:bg-red-900/30 text-red-700 dark:text-red-300 rounded-xl text-sm border border-red-100 dark:border-red-800 flex items-center gap-3 font-medium">
            <SafeIcon name="AlertCircle" className="w-5 h-5 flex-shrink-0" />
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-5">
          <Input
            label="Email Cím"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            placeholder="email@pelda.hu"
          />
          <Input
            label="Jelszó"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            placeholder="••••••••"
          />
          <Button type="submit" className="w-full py-4 mt-4 text-lg font-bold shadow-md">
            Belépés a rendszerbe
          </Button>
        </form>

        <div className="mt-8 pt-6 border-t border-gray-100 dark:border-gray-700 text-center">
          <p className="text-sm text-gray-400 dark:text-gray-500">
            &copy; {new Date().getFullYear()} SocialCard Review. Minden jog fenntartva.
          </p>
        </div>
      </Card>
    </div>
  );
};

export default Login;
